package meineglasfaser.frontend.common.components.widgets

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.disabled
import com.varabyte.kobweb.compose.dom.GenericTag
import org.jetbrains.compose.web.attributes.AttrsScope
import org.jetbrains.compose.web.dom.ElementScope
import org.w3c.dom.HTMLDetailsElement
import org.w3c.dom.HTMLDialogElement
import org.w3c.dom.HTMLElement

@Composable
fun Details(
    attrs: (AttrsScope<HTMLDetailsElement>.() -> Unit)? = null,
    content: @Composable (ElementScope<HTMLDetailsElement>.() -> Unit)? = null,
) {
    GenericTag(
        name = "details",
        namespace = null,
        attrs = attrs,
        content = content,
    )
}

@Composable
fun Summary(
    attrs: (AttrsScope<HTMLElement>.() -> Unit)? = null,
    content: @Composable (ElementScope<HTMLElement>.() -> Unit)? = null,
) {
    GenericTag(
        name = "summary",
        namespace = null,
        attrs = attrs,
        content = content,
    )
}

@Composable
fun Dialog(
    attrs: (AttrsScope<HTMLDialogElement>.() -> Unit)? = null,
    content: @Composable (ElementScope<HTMLDialogElement>.() -> Unit)? = null,
) {
    GenericTag(
        name = "dialog",
        namespace = null,
        attrs = attrs,
        content = content,
    )
}

fun AttrsScope<HTMLElement>.ariaBusy() {
    attr("aria-busy", "true")
}

fun AttrsScope<HTMLElement>.ariaBusyAndDisabled() {
    ariaBusy()
    disabled(true)
}
